import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-custom-btn",
  templateUrl: "./custom-btn.component.html",
  styleUrls: ["./custom-btn.component.css"]
})
export class CustomBtnComponent {
  @Input() disabled: boolean;
  @Input() customClass: string | string[];
  @Input() customStyle: { [key: string]: string };
  @Output() click = new EventEmitter<void>();

  handleClick(event: Event): void {
    event.stopPropagation();
    this.click.emit();
  }
}
